import React, { useEffect } from "react";
import {
  ArrowDownIcon,
  ArrowUpIcon,
  BoxIconLine,
  GroupIcon,
} from "../../icons";
import Badge from "../ui/badge/Badge";
import { useTranslation } from "react-i18next";

interface DataUserProps {
  dataUser: {
    count: number;
    percentageChange: string;
    isIncrease: boolean;
  };
  dataDeck: {
    count: number;
    percentageChange: string;
    isIncrease: boolean;
  };
}

export default function EcommerceMetrics({ dataUser, dataDeck }: DataUserProps) {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-6">
      {/* <!-- Metric Item Start --> */}
      <div className="rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/[0.03] md:p-6">
        <div className="flex items-center justify-center w-12 h-12 bg-gray-100 rounded-xl dark:bg-gray-800">
          <GroupIcon className="text-gray-800 size-6 dark:text-white/90" />
        </div>

        <div className="flex items-end justify-between mt-5">
          <div>
            <span className="text-sm text-gray-500 dark:text-gray-400">
              {t("Users")}
            </span>
            <h4 className="mt-2 font-bold text-gray-800 text-title-sm dark:text-white/90">
              {dataUser.count}
            </h4>
          </div>
          {dataUser.isIncrease ? (
            <Badge color="success">
              <ArrowUpIcon />
              {dataUser.percentageChange}%
            </Badge>
          ) : (
            <Badge color="error">
              <ArrowDownIcon />
              {dataUser.percentageChange}%
            </Badge>
          )}
        </div>
      </div>
      {/* <!-- Metric Item End --> */}

      {/* <!-- Metric Item Start --> */}
      <div className="rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/[0.03] md:p-6">
        <div className="flex items-center justify-center w-12 h-12 bg-gray-100 rounded-xl dark:bg-gray-800">
          <BoxIconLine className="text-gray-800 dark:text-white/90" />
        </div>
        <div className="flex items-end justify-between mt-5">
          <div>
            <span className="text-sm text-gray-500 dark:text-gray-400">
              {t("Decks")}
            </span>
            <h4 className="mt-2 font-bold text-gray-800 text-title-sm dark:text-white/90">
              {dataDeck.count}
            </h4>
          </div>
          {dataDeck.isIncrease ? (
            <Badge color="success">
              <ArrowUpIcon />
              {dataDeck.percentageChange}%
            </Badge>
          ) : (
            <Badge color="error">
              <ArrowDownIcon />
              {dataDeck.percentageChange}%
            </Badge>
          )}
        </div>
      </div>
      {/* <!-- Metric Item End --> */}
    </div>
  );
}
